import styles from './style.module.scss'

export const BacktoPagetopButton = () => {
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }
  return (
    <div
      className={styles.backtotop}
      onClick={scrollTop}
      title="ページトップへ戻る"
    ></div>
  )
}

export default BacktoPagetopButton
